import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import filterImg from '../../assets/images/filtros.svg';
import close from '../../assets/images/close.svg';

import './filterModal.scss';

const FilterModal = ({
  closeModal,
  selectedGenderFilter,
  setSelectedGenderFilter,
  selectedTeamGenderFilter,
  setSelectedTeamGenderFilter,
  distanceFilter,
  setDistanceFilter,
  distanceTeamFilter,
  setDistanceTeamFilter,
  setChangeIndividual,
  selectedTab,
}) => {
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedTeamGender, setSelectedTeamGender] = useState(null);
  const [distance, setDistance] = useState(null);
  const [distanceTeam, setDistanceTeam] = useState(null);

  useEffect(() => {
    setSelectedGender(selectedGenderFilter);
    setSelectedTeamGender(selectedTeamGenderFilter);
    setDistance(distanceFilter);
    setDistanceTeam(distanceTeamFilter);
  }, []);

  const filter = () => {
    setSelectedGenderFilter(selectedGender);
    setSelectedTeamGenderFilter(selectedTeamGender);
    setDistanceFilter(distance);
    setDistanceTeamFilter(distanceTeam);

    closeModal();
    setChangeIndividual(new Date().getTime());
    window.scrollTo(0, 0);
  };

  return (
    <div className='filter-modal'>
      <div className='filter-modal_card'>
        <div className='filter-modal_card-header'>
          <div className='filter-modal_card-header-left'>
            <img
              src={filterImg}
              alt='filter'
              className='filter-modal_card-header_filter'
            />
            <div className='filter-modal_card-header_title'>FILTROS</div>
            <div
              className='close-button'
              onClick={() => {
                closeModal();
              }}
            >
              <img src={close} alt='close' className='close-icon' />
            </div>
          </div>
        </div>
        <div className='filter-modal_card-body'>
          {selectedTab === 0 ? (
            <div className='filter-modal_card-section'>
              <div className='filter-modal_card-section-title'>GENERO</div>
              <div className='tags-container'>
                <div
                  onClick={() => {
                    setSelectedGender(null);
                  }}
                  className={`tag${!selectedGender ? ' selected' : ''}`}
                >
                  Todos
                </div>
                <div
                  onClick={() => {
                    setSelectedGender('male');
                  }}
                  className={`tag${
                    selectedGender === 'male' ? ' selected' : ''
                  }`}
                >
                  Hombres
                </div>
                <div
                  onClick={() => {
                    setSelectedGender('female');
                  }}
                  className={`tag${
                    selectedGender === 'female' ? ' selected' : ''
                  }`}
                >
                  Mujeres
                </div>
              </div>
            </div>
          ) : (
            <div className='filter-modal_card-section'>
              <div className='filter-modal_card-section-title'>GENERO</div>
              <div className='tags-container'>
                <div
                  onClick={() => {
                    setSelectedGender(null);
                  }}
                  className={`tag${!selectedTeamGender ? ' selected' : ''}`}
                >
                  Todos
                </div>
                <div
                  onClick={() => {
                    setSelectedTeamGender('MEN');
                  }}
                  className={`tag${
                    selectedTeamGender === 'MEN' ? ' selected' : ''
                  }`}
                >
                  Hombres
                </div>
                <div
                  onClick={() => {
                    setSelectedTeamGender('WOMEN');
                  }}
                  className={`tag${
                    selectedTeamGender === 'WOMEN' ? ' selected' : ''
                  }`}
                >
                  Mujeres
                </div>
                <div
                  onClick={() => {
                    setSelectedTeamGender('MIXED');
                  }}
                  className={`tag${
                    selectedTeamGender === 'MIXED' ? ' selected' : ''
                  }`}
                >
                  Mixto
                </div>
              </div>
            </div>
          )}
          {/* {selectedTab === 0 ? (
            <div className='filter-modal_card-section'>
              <div className='filter-modal_card-section-title'>DISTANCIA</div>
              <div className='tags-container'>
                <div
                  onClick={() => {
                    setDistance(null);
                  }}
                  className={`tag${distance == null ? ' selected' : ''}`}
                >
                  Todas
                </div>

                <div
                  onClick={() => {
                    setDistance(1);
                  }}
                  className={`tag${distance === 1 ? ' selected' : ''}`}
                >
                  16K
                </div>
                <div
                  onClick={() => {
                    setDistance(2);
                  }}
                  className={`tag${distance === 2 ? ' selected' : ''}`}
                >
                  22K
                </div>
                <div
                  onClick={() => {
                    setDistance(0);
                  }}
                  className={`tag${distance === 0 ? ' selected' : ''}`}
                >
                  HALF
                </div>
                <div
                  onClick={() => {
                    setDistance(3);
                  }}
                  className={`tag${distance === 3 ? ' selected' : ''}`}
                >
                  EPIC
                </div>
              </div>
            </div>
          ) : (
            <div className='filter-modal_card-section'>
              <div className='filter-modal_card-section-title'>DISTANCIA</div>
              <div className='tags-container'>
                <div
                  onClick={() => {
                    setDistanceTeam(null);
                  }}
                  className={`tag${distanceTeam == null ? ' selected' : ''}`}
                >
                  Todas
                </div>
                <div
                  onClick={() => {
                    setDistanceTeam(1);
                  }}
                  className={`tag${distanceTeam === 1 ? ' selected' : ''}`}
                >
                  50K
                </div>
                <div
                  onClick={() => {
                    setDistanceTeam(2);
                  }}
                  className={`tag${distanceTeam === 2 ? ' selected' : ''}`}
                >
                  100K
                </div>
                <div
                  onClick={() => {
                    setDistanceTeam(3);
                  }}
                  className={`tag${distanceTeam === 3 ? ' selected' : ''}`}
                >
                  12H
                </div>
              </div>
            </div>
          )} */}
          <button onClick={filter} className='filter-button'>
            Filtrar
          </button>
        </div>
      </div>
    </div>
  );
};

FilterModal.propTypes = {
  selectedGenderFilter: PropTypes.string,
  setSelectedGenderFilter: PropTypes.func.isRequired,
  selectedTeamGenderFilter: PropTypes.string,
  setSelectedTeamGenderFilter: PropTypes.func.isRequired,
  distanceFilter: PropTypes.string,
  setDistanceFilter: PropTypes.func.isRequired,
  distanceTeamFilter: PropTypes.string,
  setDistanceTeamFilter: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  setChangeIndividual: PropTypes.func.isRequired,
  selectedTab: PropTypes.number.isRequired,
};

FilterModal.defaultProps = {
  selectedGenderFilter: null,
  selectedTeamGenderFilter: null,
  distanceFilter: null,
  distanceTeamFilter: null,
};

export default FilterModal;
